import React from "react";
import Header from "./Header/Header";
import Footer from "./Footer/Footer";
import { Outlet } from "react-router-dom";
import ScrollToTop from "../../utils/ScrollToTop";
import Slider from "../../Sections/Slider";
import OurFeatures from "../../Sections/OurFeatures";
import OurOffers from "../../Sections/OurOffers";

function RootLayout() {
  return (
    <>
      <ScrollToTop />
      <Header />
      {/* <Slider /> */}
      <Outlet />
      {/* <OurFeatures /> */}
      {/* <OurOffers /> */}
      <Footer />
    </>
  );
}

export default RootLayout;
